export default __webpack_public_path__ + "static/media/VISUAL_AND_PERFORMING_ARTS_STUDIO_ART.abace260.svg";